export function getGA4ClientId(): string | null {
  const cookie = document.cookie.split("; ").find((c) => c.startsWith("_ga="));
  if (!cookie) return null;

  const parts = cookie.split(".");
  return parts.slice(-2).join(".");
}

export function getGA4SessionId(): string | null {
  const cookie = document.cookie.split("; ").find((c) => c.startsWith("_ga_"));

  if (!cookie) return null;

  const value = cookie.split("=")[1];

  const parts = value.split(".");
  if (parts.length < 3) return null;

  const sessionFragment = parts[2];

  const match = sessionFragment.match(/^s(\d+)/);

  return match ? match[1] : null;
}
